import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import IntersectionObserver from "./use-intersection-observer";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-intersection-observer"
    }}>{`use-intersection-observer`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<IntersectionObserver />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      IntersectionObserver
    }} mdxType="Playground">
  <IntersectionObserver mdxType="IntersectionObserver" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useRef } from "react";
import { useIntersectionObserver } from "react-hooks-lab";

const IntersectionObserver = () => {
  const containerRef = useRef(null);
  const isIntersecting = useIntersectionObserver(containerRef, { rootMargin: "-200px" });

  const containerRef2 = useRef(null);
  const isIntersecting2 = useIntersectionObserver(containerRef, { rootMargin: "-200px", triggerOnce: false });

  return (
    <>
      <div>White Space</div>

      <span>Watching intersect using -200px of rootMargin</span>
      <span>Triggering multiple times</span>
      <div ref={containerRef2}>{isIntersecting2 ? "Intersected" : "Not Yet"}</div>

      <span>Watching intersect using -200px of rootMargin</span>
      <span>Triggering once</span>
      <div ref={containerRef}>{isIntersecting ? "Intersected" : "Not Yet"}</div>
    </>
  );
};
export default IntersectionObserver;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      